import { render, staticRenderFns } from "./BirthdayReminder.vue?vue&type=template&id=e9b07354&"
import script from "./BirthdayReminder.vue?vue&type=script&lang=js&"
export * from "./BirthdayReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports